import { createFileRoute } from "@tanstack/react-router";

import ComingSoonCover from "@/components/ComingSoonCover";

export const Route = createFileRoute(
  "/_staff/time-and-attendance/_layout/_placeholders/attendances",
)({
  component: () => <ComingSoonCover />,
});
